export enum ContentTypeIds {
  InspirationQuotePage = 'inspirationQuotePage',
  CustomerQuote = 'customerQuote',
  PricingPackage = 'pricingPackage',
  FrequentlyAskedQuestion = 'frequentlyAskedQuestion'
}
